var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.00195312C7.16333 0.00195312 0 7.16529 0 16.002C0 24.8386 7.16333 32.002 16 32.002C24.8367 32.002 32 24.8386 32 16.002C32 7.16529 24.8367 0.00195312 16 0.00195312ZM19.79 11.0586H17.385C17.1 11.0586 16.7833 11.4336 16.7833 11.932V13.6686H19.7917L19.3367 16.1453H16.7833V23.5803H13.945V16.1453H11.37V13.6686H13.945V12.212C13.945 10.122 15.395 8.42362 17.385 8.42362H19.79V11.0586Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIcon);
export default __webpack_public_path__ + "static/media/fbIcon.91def3a6.svg";
export { ForwardRef as ReactComponent };